document.querySelectorAll('.report-block').forEach(block => {
    const blockId = block.dataset.blockId;

    let activeButton = block.querySelector('[data-report-tag="all"]');
    let activeYear = null;

    const reports = block.querySelectorAll(`#reportsList-${blockId} li`);
    const resultsEl = block.querySelector(`#reportResults-${blockId}`);
    const reportsPerPage = 4;
    let currentPage = 1;
    let filteredReports = [];

    block.querySelectorAll('[data-report-tag]').forEach(button => {
        button.addEventListener('click', e => {
            e.preventDefault();

            if (activeButton) activeButton.classList.replace('btn-secondary', 'btn-gray');
            button.classList.replace('btn-gray', 'btn-secondary');
            activeButton = button;

            currentPage = 1;
            filterReports(activeButton.dataset.reportTag, activeYear);
        });
    });

    const yearButton = block.querySelector(`#yearDropdownButton-${blockId}`);
    const yearMenu = block.querySelector(`#yearDropdownMenu-${blockId}`);
    const selectedYearSpan = block.querySelector(`#reportSelectedYear-${blockId}`);

    if (yearButton) {
        yearButton.addEventListener('click', () => {
            yearMenu.classList.toggle('hidden!');

            if (activeYear) {
                yearButton.classList.replace('btn-secondary', 'btn-gray');
                currentPage = 1;
                filterReports(activeButton.dataset.reportTag, activeYear);
            }
        });

        yearMenu.querySelectorAll('.dropdown-item').forEach(item => {
            item.addEventListener('click', () => {
                activeYear = item.dataset.year;
                selectedYearSpan.innerHTML =
                    activeYear +
                    '<span id="remove-selected-year-filter-' +
                    blockId +
                    '" class="btn-square btn-xs cursor-pointer ml-1"><svg class="fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">\n' +
                    '    <path d="M7.5 105c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l151 151 151-151c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-151 151 151 151c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-151-151-151 151c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l151-151-151-151z"/>\n' +
                    '</svg></span>';

                yearButton.classList.replace('btn-gray', 'btn-secondary');

                yearMenu.classList.add('hidden!');

                currentPage = 1;
                filterReports(activeButton.dataset.reportTag, activeYear);
            });
        });

        selectedYearSpan.addEventListener('click', (e) => {
            if (e.target.id === 'remove-selected-year-filter-' + blockId) {
                activeYear = null;
                selectedYearSpan.textContent = '';
                yearButton.classList.replace('btn-secondary', 'btn-gray');
                currentPage = 1;
                filterReports(activeButton.dataset.reportTag, null);
            }
        });

        document.addEventListener('click', e => {
            if (!yearButton.contains(e.target) && !yearMenu.contains(e.target)) {
                yearMenu.classList.add('hidden!');
            }
        });
    }

    function filterReports(tag, year = null) {
        filteredReports = [];

        reports.forEach(report => {
            const tags = report.dataset.reportTags;
            const reportYear = report.dataset.reportYear;

            const matchesTag = tag === 'all' || tags.includes(tag);
            const matchesYear = !year || reportYear === year;

            if (matchesTag && matchesYear) {
                report.classList.remove('hidden!');
                filteredReports.push(report);
            } else {
                report.classList.add('hidden!');
            }

            report.classList.remove('last-visible');
        });

        paginateReports();
    }

    function paginateReports() {
        const start = (currentPage - 1) * reportsPerPage;
        const end = start + reportsPerPage;

        filteredReports.forEach((report, index) => {
            report.classList.toggle('hidden!', index < start || index >= end);
        });

        if (filteredReports.length) {
            filteredReports[Math.min(end - 1, filteredReports.length - 1)].classList.add('last-visible');
        }

        resultsCount(start + 1, Math.min(end, filteredReports.length), filteredReports.length);
        renderPaginationButtons();
    }

    function resultsCount(startShowing, endShowing, total) {
        resultsEl.innerText = total
            ? `Showing ${startShowing} - ${endShowing} of ${total} total results`
            : 'No results found';
    }

    function renderPaginationButtons() {
        const paginationEl = block.querySelector(`#pagination-${blockId}`);
        if (!paginationEl) return;

        paginationEl.innerHTML = '';
        const totalPages = Math.ceil(filteredReports.length / reportsPerPage);

        if (totalPages <= 1) {
            paginationEl.classList.add('hidden')
        } else {
            paginationEl.classList.remove('hidden')
        }

        for (let i = 1; i <= totalPages; i++) {
            const btn = document.createElement('button');
            btn.innerText = i;
            btn.classList.add('btn', i === currentPage ? 'btn-secondary' : 'btn-gray');
            btn.addEventListener('click', () => {
                currentPage = i;
                paginateReports();
            });
            paginationEl.appendChild(btn);
        }
    }

    filterReports('all');
});
